const page404 = {
  page404: {
    startTyping: "Куда вы хотите поехать?",
    linkToMainText: "На главную",
    linkToSearchText: "Найти путешествие",
  },
};

export { page404 };
